import React from 'react';

const MarketingManager = () => {
  return (
    <>
      <div className="flex justify-between">
        <div className="flex flex-col">
          <div className="fredokaOne flex text-[40px]  leading-normal tracking-[-0.8px] text-[#012E33]">
            Marketing Manager
          </div>
          <div className="mt-1 flex flex-wrap">
            <div className="mb-2 mr-2 flex items-center sm:mb-0">
              <img src="/images/icons/Building-1.svg" alt="IAMAI" className="mr-2 h-6 w-6" />
              <span className="text-[#678285]">IAMAI</span>
            </div>
            <div className="mb-2 mr-2 flex items-center sm:mb-0">
              <img src="/images/icons/Clock.svg" alt="Clock" className="mr-2 h-6 w-6" />
              <span className="text-[#678285]">Full-time</span>
            </div>
            <div className="mb-2 mr-2 flex items-center sm:mb-0">
              <img src="/images/icons/MapPin.svg" alt="MapPin" className="mr-2 h-6 w-6" />
              <span className="text-[#678285]">Remote</span>
            </div>
            <div className="mb-2 flex items-center sm:mb-0">
              <img
                src="/images/icons/CalendarBlank.svg"
                alt="CalendarBlank"
                className="mr-2 h-6 w-6"
              />
              <span className="text-[#678285]">Posted 5 days ago</span>
            </div>
          </div>
        </div>

        <div className="box-border hidden h-1/2 w-[189px] rounded-[16px] bg-[#FC823E] py-[10px] text-center font-medium text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] lg:flex">
          <a href="#hellomom" className="w-full px-4">
            Apply Now
          </a>
        </div>
      </div>
    </>
  );
};

export default MarketingManager;
